import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const baseCls = 'lt-room-info-description';

const RoomDescription = ({ className, title, children }) => (
  <div className={cn(baseCls, { [className]: !!className })}>
    <div className={`${baseCls}__title`}>{title}</div>
    <div className={`${baseCls}__content`}>{children}</div>
  </div>
);

RoomDescription.defaultProps = {
  className: '',
};

RoomDescription.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default RoomDescription;
